<template>
  <div>
    
  </div>
</template>

<script>
export default {
  name: "logout",

  data() {
    return {
    }
  },

  created() {
    this.logout()
  },

  methods: {
    logout() {
      this.$api.loginOut().then(res => {
        if (!res.data?.meta?.success) {
          this.logoutFail(res.data.meta.message)
          return
        }
        this.logoutSuccess(res.data)        
      }).catch(err => {
        console.log('logout err:', err)
      })
    },

    logoutFail(message) {
      console.log('logout fail: message=', message)
      this.$message({ message, type: "error" })
    },

    logoutSuccess(data) {
      console.log('logout success: data=', data)
      // 清除本地登录信息
      localStorage.removeItem('role')
      localStorage.removeItem('user')
      localStorage.removeItem('lcSteps')
      localStorage.removeItem('xmmc')
      localStorage.removeItem('tbtsnr')
      localStorage.removeItem("jgdm")
      localStorage.removeItem('bdId')
      localStorage.removeItem('kbxmZt')
      localStorage.removeItem('searchObj')

      if (!data.location) {
        this.$router.push('/login')
      } else {
        location.href = data.location
      }
    }
  }
};
</script>